import { render, staticRenderFns } from "./orgLabel.vue?vue&type=template&id=a7ac2820&scoped=true&"
import script from "./orgLabel.vue?vue&type=script&lang=js&"
export * from "./orgLabel.vue?vue&type=script&lang=js&"
import style0 from "./orgLabel.vue?vue&type=style&index=0&id=a7ac2820&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ac2820",
  null
  
)

export default component.exports